import type { RootState } from "../reducers/main";

export const selectSeriesList = (state: RootState) => state.SeriesReducer.seriesList;
export const selectCurrentSeries = (state: RootState) => state.SeriesReducer.currentSeries;
export const selectIsLoadingSeriesList = (state: RootState) => state.SeriesReducer.loadingSeriesList;
export const selectIsLoadingCurrentSeries = (state: RootState) => state.SeriesReducer.loadingCurrentSeries;
export const selectSeriesError = (state: RootState) => state.SeriesReducer.seriesError;
export const selectTopDrawerOpen = (state: RootState) => state.SeriesReducer.topDrawerOpen;
export const selectTotalSeries = (state: RootState) => state.SeriesReducer.totalSeries;
